// global
import React, { Component, memo } from 'react';
import PropTypes from 'prop-types';
// api
import * as Clients from 'app/api/clients';
// views
import CustomDropdown from 'app/components/commons/dropdown/CustomDropdown';
import ErrorLabel from 'app/components/commons/label/ErrorLabel';
import { sortString } from 'app/utils';

class ClientsDropdown extends Component {
  state = {
    loading: true,
    options: []
  };

  componentDidMount() {
    Clients.getClients().then(this.onLoadClientSuccess).catch(this.onLoadClientFail);
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  onLoadClientSuccess = clients => {
    clients = clients.map(client => ({
      text: client.name,
      value: parseInt(client.id)
    }));
    clients.sort((a, b) => sortString(a.text, b.text));

    const options = [{ text: '-', value: null }, ...clients];

    if (this._isMounted) {
      this.setState({
        loading: false,
        options
      });
    }
  };

  onLoadClientFail = () => {
    if (this._isMounted) {
      this.setState({
        loading: false,
        options: []
      });
    }
  };

  render() {
    const { options, loading } = this.state;
    const {
      value,
      onChange,
      error,
      isForm,
      width,
      required,
      disabled,
      showLabel,
      label,
      placeholder,
      styleName
    } = this.props;

    return (
      <CustomDropdown
        loading={loading}
        options={options}
        value={value}
        onChange={onChange}
        error={error ? true : false}
        isForm={isForm}
        width={width}
        required={required}
        placeholder={placeholder}
        disabled={disabled}
        styleName={styleName}
        label={showLabel && <ErrorLabel label={label} error={error} />}
        selection
      />
    );
  }
}

ClientsDropdown.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  error: PropTypes.string,
  isForm: PropTypes.bool,
  width: PropTypes.number,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  showLabel: PropTypes.bool,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  styleName: PropTypes.oneOf(['styleModal', 'styleReport'])
};

ClientsDropdown.defaultProps = {
  isForm: true,
  showLabel: true,
  label: 'Cliente',
  placeholder: 'Cliente',
  styleName: 'styleModal'
};

export default memo(ClientsDropdown);
